import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/GitHubLine.svg?component
var GitHubLine_exports = /* @__PURE__ */ __exportAll({
	default: () => GitHubLine_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M16.643 22.94v-3.135a3.68 3.68 0 0 0-1.026-2.852c3.43-.382 7.036-1.682 7.036-7.648a5.94 5.94 0 0 0-1.64-4.097 5.54 5.54 0 0 0-.097-4.12s-1.29-.382-4.272 1.618a14.6 14.6 0 0 0-7.649 0c-2.982-2-4.272-1.617-4.272-1.617a5.54 5.54 0 0 0-.098 4.119 5.94 5.94 0 0 0-1.639 4.13c0 5.922 3.606 7.222 7.036 7.648a3.68 3.68 0 0 0-1.027 2.819v3.136m0-2.186c-3.277 1.064-6.009 0-7.648-3.278" }, null, -1)])]);
}
var GitHubLine_default = { render: render$1 };
//#endregion
export { GitHubLine_exports, GitHubLine_default as default, render$1 as render };

//# sourceMappingURL=GitHubLine.svg.virtual.js.map